export enum TradePath {
  ethToErc20 = "ethToErc20",
  erc20ToEth = "erc20ToEth",
  erc20ToErc20 = "erc20ToErc20",
}
